import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "old-messages",
        path: "/old-messages",
        component: () => import("./components/MessageTileContainer.vue"),
    },
    {
        name: "user-profile",
        path: "/user-profile",
        component: () => import("./components/SingleTileContainer.vue"),
        props: { tileId: "user-profile-tile" },
    },
];

export default routes;
